<template>
    <div :class="[viewList ? 'main_data_div main_data_div_nolist' : 'main_data_div']">
        <div class="col-md-12  p-left-0 p-right-0 ">
            <div class="col-md-6 col-xs-6 p-left-0 ">
                <p class="select-services-dropdown-title font_title" v-if="viewList"> Contact Attempts </p>
                <p class="select-services-dropdown-title" v-else> Contact Attempts </p>
            </div>
            <div class="col-md-6 col-xs-6 p-right-0">
                <p  class="font-size-18 bold p-bottom-10">
                    <span  style="cursor: pointer;">
                        <span class="float-right" style="">
                            <a href="javascript:;" @click="showAddPopup(itemId)">
                                <svg  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path  d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#03A9F4"></path>
                                </svg>
                            </a>
                        </span>
                    </span>
                </p>
            </div>
        </div>
        <div class="row scrollbox"   v-if="localReminderHistory.length > 0">
            <div class="col-md-12 col-xs-12"  v-for="(reminder, index) in  localReminderHistory"  style="margin-bottom: 20px;">
                <a :href="`/settings/user-info/${reminder.user_id}`" target="_blank">
                    <img :src="reminder.avatar_link"
                         width="30" height="30" class="img-circle"
                         alt="profile" border="2"
                         style="border:1px solid #48bc5a; margin-right: 10px;">

                    <a href="javascript:;"  @click="showViewPopup(reminder)">
                        {{reminder.contact_history_created_converted}}
                    </a>
                </a>
            </div>
        </div>
        <div class="row"  v-else>
            <div class="col-md-12">
                No Contact Attempts Added
            </div>
        </div>

        <confirmation-popup
            title="View Contact Attempt"
            message=""
            id="reminderContactViewId"  cancel-btn-text="Close"  :show-confirm-btn="false">
            <reminder-single-view
                :key="itemId"
                :remind-single = "localRemindSingle"
                :item-id = "itemId"
            ></reminder-single-view>
        </confirmation-popup>

        <confirmation-popup
            title="Add Contact Attempt"
            message=""
            :id="getReminderFormRef()" confirm-btn-text="Submit" :closeAfterConfirm="false"
            @on-confirm="submitReminder()"
        >
            <form :ref="getReminderFormRef()">
                <reminder-add-view
                    :key="itemId"
                    :item-id = "itemId"
                ></reminder-add-view>
            </form>
        </confirmation-popup>
    </div>


</template>

<script>


import {EventBus} from "@/events/event-bus";
import {iSMobileDevice} from "@/events/sharedMethods";
import {getReminderView, addReminderView} from "@/modules/Booking/api/contactReminder/";
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";
import {getReminders} from "@/modules/Booking/api/contactReminder/";

export default {
    name: "contactsReminder",
    components: {ConfirmationPopup},
    props: {
        viewPage:false,
        viewList:false,
        itemType:'inquiry_id',
        itemId:'',
        inquiryReminderAdd:false,
        reminderHistory:'',
        remindSingle:'',
        getTemplateEmailAttempAccount:'',
        getTemplateSmsAttempAccount:'',
    },
    data() {
        return {
            viewPage:this.viewPage,
            itemId:this.itemId,
            localRemindSingle: this.remindSingle,
            localReminderHistory:  this.reminderHistory ? [...this.reminderHistory] : [],
            remindSingle:this.remindSingle,
        }
    },

    mounted() {
        this.initiateListeners();
        this.getRemindersList();
    },
    methods: {
        getReminderFormRef() {
            return `reminderForm${this.itemId}`;
        },
        showAddPopup(id){
            EventBus.$emit('viewModal', id);
            const idnew = '#'+this.getReminderFormRef();
            $(idnew).modal('show');
        },
        showViewPopup(reminder){
            EventBus.$emit('viewSingleModal', reminder);
            $("#reminderContactViewId").modal('show');
        },
        initiateListeners() {
            EventBus.$on('onDeletedReminder', remindId => {
                this.localReminderHistory =  this.localReminderHistory.filter(
                    (item) => item.contact_history_id != remindId
                );
                $("#reminderContactViewId").modal('hide');
            })
        },
        clickSubmit(){
            EventBus.$emit('reminderSubmit', value => {});
        },
        getRemindersList(){
            getReminders(this.itemId).then(response => {
                this.reminderHistory = response.data.reminder_history;
                this.localReminderHistory =   this.reminderHistory ? [...this.reminderHistory] : [];
            });
        },
        submitReminder(){
            const formRef = `reminderForm${this.itemId}`; // Dynamically generate form reference
            const form = this.$refs[formRef];
            if (form instanceof HTMLFormElement) {
                const formData = new FormData(form);
                // Now you can work with formData, for example, send it via AJAX
                addReminderView(this.itemId, formData).then((response) => {
                    if(this.itemId == response.data.inquiry_id){
                        $.notify('add reminder successfully', 'success');
                        this.localReminderHistory.push(response.data);
                        EventBus.$emit('addOnModel', this.localReminderHistory, this.itemId);
                    }
                })
                .catch((error) => {
                    // Handle any errors here
                });
            } else {
                console.error('Invalid form reference');
            }
        },


    },
    watch: {

    }
}


</script>

<style scoped>
.location_icon_section_title{
    color: var(--Navy, #2E4051);
    /* Title/Left/H4 */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
}

.select-services-dropdown-title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #2E4051;
}

.scrollbox{
    max-height: 100px;
    overflow-y: scroll;
    margin-right: 0px;
}

.font_title{
    font-size: 15px !important;
}


@media (max-width: 768px) {
    .main_data_div{
        padding: 15px 18px 0px;
        border-top: 20px solid #f3f3f4;
        border-bottom: 20px solid #f3f3f4;
    }
    .main_data_div_nolist{
        padding: 0px;
        border-top: 0px solid #f3f3f4;
        border-bottom: 0px solid #f3f3f4;
    }
    .scrollbox{
        overflow-y: scroll;
        max-height: 100px;
        width: 100%;
    }
}

</style>